import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { Loader2 } from "lucide-react";
import { Logo, LangToggle } from "@/components/Brand";
import { AudioPlayer } from "@/components/meeting/AudioPlayer";
import { SummaryTab } from "@/components/meeting/SummaryTab";
import { ParagraphView } from "@/components/meeting/TranscriptViews";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { API, api } from "@/lib/api";
import { useApp } from "@/lib/i18n";

export default function SharedMeeting() {
  const { token } = useParams();
  const { L } = useApp();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const player = useRef(null);
  useEffect(() => { api.get(`/public/share/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "Ralat")); }, [token]);
  const seek = (t) => player.current?.seek(t);
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="shared-meeting-page">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4"><Logo /><LangToggle /></header>
      <main className="mx-auto max-w-4xl px-4 py-8">
        {err && <p className="rounded-xl bg-red-50 p-4 text-red-700" data-testid="share-error">{err}</p>}
        {!d && !err && <Loader2 className="animate-spin text-violet-600" />}
        {d && (
          <>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{L("Baca sahaja · luput", "Read only · expires")} {new Date(d.expires_at).toLocaleDateString()}</p>
            <h1 className="mt-2 text-2xl font-extrabold sm:text-3xl">{d.meeting.title}</h1>
            <p className="text-sm text-slate-500">{d.meeting.meeting_date}</p>
            {d.include_audio && <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-3"><AudioPlayer ref={player} publicUrl={`${API}/public/share/${token}/audio`} /></div>}
            <Tabs defaultValue="summary" className="mt-6">
              <TabsList className="rounded-xl bg-slate-100">
                <TabsTrigger value="summary" data-testid="share-tab-summary">{L("Ringkasan", "Summary")}</TabsTrigger>
                <TabsTrigger value="minutes" data-testid="share-tab-minutes">{L("Minit", "Minutes")}</TabsTrigger>
                <TabsTrigger value="transcript" data-testid="share-tab-transcript">{L("Transkrip", "Transcript")}</TabsTrigger>
              </TabsList>
              <TabsContent value="summary" className="mt-4"><SummaryTab notes={d.notes} onSeek={d.include_audio ? seek : null} /></TabsContent>
              <TabsContent value="minutes" className="mt-4"><div className="prose-minit rounded-2xl border border-slate-200 bg-white p-6"><ReactMarkdown>{d.notes?.content?.minutes_markdown || ""}</ReactMarkdown></div></TabsContent>
              <TabsContent value="transcript" className="mt-4"><div className="rounded-2xl border border-slate-200 bg-white p-4"><ParagraphView segs={d.segments} sections={d.meeting.transcript_sections || []} names={d.meeting.speaker_names || {}} version="clean" current={-1} q="" onSeek={d.include_audio ? seek : null} showTs /></div></TabsContent>
            </Tabs>
          </>
        )}
      </main>
    </div>
  );
}
